<p-datePicker
  [showIcon]="true"
  hourFormat="24"
  dateFormat="dd-mm-yy"
  appendTo="body"
  [disabled]="isDisabled"
  [ngModel]="valueSignal()"
  [showButtonBar]="true"
  (ngModelChange)="onValueChange($event)"
  [placeholder]="placeholder()"
  [showTime]="showTime()" />
